const MOBILE_LANGUAGES = ['en', 'fr', 'de', 'it'];

export default MOBILE_LANGUAGES;
